/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ExchangeTokenData = core.serialization.object({
    valid: core.serialization.boolean(),
    token: core.serialization.string().optional(),
    sentTo: core.serialization.string().optional(),
});
